export const PHONE_NUMBER_REGEX =
  // eslint-disable-next-line no-useless-escape
  /^[\+]?([0-9][\s]?|[0-9]?)([(][0-9]{3}[)][\s]?|[0-9]{3}[-\s\.]?)[0-9]{3}[-\s\.]?[0-9]{4,6}$/;

export const ZIP_CODE_REGEX = /^[0-9]{5}(?:-[0-9]{4})?$/;
